module.exports = __webpack_public_path__ + "d688dcd9508ead871099b0a332b8443c.png";